// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1jasB","detailsBorder":"styles_detailsBorder__OcQxe"};